<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [showHeader]="false"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '460px', 'max-width': '95vw', padding: '0', overflow: 'hidden', 'border-radius': '1.5rem', border: 'none' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden', 'border-radius': '1.5rem' }"
  appendTo="body"
  (onHide)="close()"
>
  <div class="se-root">

    <!-- Animated background orbs -->
    <div class="se-bg">
      <span class="se-orb se-orb-1"></span>
      <span class="se-orb se-orb-2"></span>
      <span class="se-orb se-orb-3"></span>
      <span class="se-orb se-orb-4"></span>
      <span class="se-orb se-orb-5"></span>
    </div>

    <!-- Card -->
    <div class="se-card">

      <!-- Close button (top-right) -->
      <button class="se-close-btn" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>

      <!-- Animated server icon -->
      <div class="se-icon-wrap">
        <svg class="se-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="10" width="48" height="12" rx="3" fill="url(#sg1)" opacity="0.9"/>
          <rect x="8" y="26" width="48" height="12" rx="3" fill="url(#sg1)" opacity="0.75"/>
          <rect x="8" y="42" width="48" height="12" rx="3" fill="url(#sg1)" opacity="0.55"/>
          <circle class="se-blink-r" cx="50" cy="16" r="3" fill="#ef4444"/>
          <circle class="se-blink-y" cx="43" cy="16" r="3" fill="#f59e0b"/>
          <circle cx="50" cy="32" r="3" fill="#22c55e" opacity="0.5"/>
          <circle cx="50" cy="48" r="3" fill="#22c55e" opacity="0.3"/>
          <line x1="13" y1="15" x2="34" y2="15" stroke="#c7d2fe" stroke-width="1.5" stroke-linecap="round" opacity="0.6"/>
          <line x1="13" y1="31" x2="34" y2="31" stroke="#c7d2fe" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
          <line x1="13" y1="47" x2="34" y2="47" stroke="#c7d2fe" stroke-width="1.5" stroke-linecap="round" opacity="0.35"/>
          <path class="se-bolt" d="M30 4 L22 20 H30 L24 36 L42 16 H33 Z" fill="#fbbf24" opacity="0.9"/>
          <defs>
            <linearGradient id="sg1" x1="8" y1="0" x2="56" y2="0" gradientUnits="userSpaceOnUse">
              <stop stop-color="#4f46e5"/><stop offset="1" stop-color="#1684AC"/>
            </linearGradient>
          </defs>
        </svg>
      </div>

      <!-- HTTP Status code -->
      <div class="se-code">{{ statusCode }}</div>

      <!-- App-level 5xxx code badge (shown when available) -->
      <div class="se-appcode-row" *ngIf="appCode">
        <span class="se-appcode-badge">
          <i class="pi pi-code"></i>&nbsp;{{ appCode }}
        </span>
        <span class="se-appcode-label" *ngIf="appCodeLabel">{{ appCodeLabel }}</span>
      </div>

      <!-- Title + subtitle -->
      <h2 class="se-heading">{{ errorTitle() }}</h2>
      <p class="se-sub">{{ errorSubtitle() }}</p>

      <!-- Reference ID -->
      <div class="se-error-id">
        <span>Ref:&nbsp;</span><code>{{ errorId }}</code>
      </div>

      <!-- ── State: idle ── -->
      <ng-container *ngIf="reportState === 'idle'">
        <div class="se-actions">
          <button class="se-btn se-btn-outline" (click)="close()">
            <i class="pi pi-times"></i> Close
          </button>
          <button class="se-btn se-btn-report" (click)="sendReport()">
            <i class="pi pi-send"></i> Send Report
          </button>
        </div>
        <p class="se-footer-hint">
          Sending a report helps our team diagnose and fix this issue faster.
        </p>
      </ng-container>

      <!-- ── State: sending ── -->
      <ng-container *ngIf="reportState === 'sending'">
        <div class="se-sending">
          <i class="pi pi-spin pi-spinner se-spinner"></i>
          <span>Sending report…</span>
        </div>
      </ng-container>

      <!-- ── State: done ── -->
      <ng-container *ngIf="reportState === 'done'">
        <div class="se-success">
          <i class="pi pi-check-circle se-success-icon"></i>
          <p class="se-success-title">Report sent successfully</p>
          <p class="se-success-sub">Our team has been notified. Please quote your error code when contacting support.</p>
          <div class="se-error-code-chip">
            <span>Your error code:&nbsp;</span>
            <code>{{ returnedErrorCode }}</code>
          </div>
        </div>
        <div class="se-actions" style="margin-top:1.25rem">
          <button class="se-btn se-btn-primary" (click)="close()">
            <i class="pi pi-check"></i> Done
          </button>
        </div>
      </ng-container>

      <!-- ── State: failed ── -->
      <ng-container *ngIf="reportState === 'failed'">
        <div class="se-fail">
          <i class="pi pi-exclamation-triangle se-fail-icon"></i>
          <p class="se-fail-text">Could not send the report. Please try again.</p>
        </div>
        <div class="se-actions">
          <button class="se-btn se-btn-outline" (click)="close()">
            <i class="pi pi-times"></i> Close
          </button>
          <button class="se-btn se-btn-report" (click)="retry()">
            <i class="pi pi-refresh"></i> Retry
          </button>
        </div>
      </ng-container>

    </div>
  </div>
</p-dialog>
